import { get, post, postNoCookies } from "../api"
import * as url from "./urls"

const postLogin = data => {
  return postNoCookies(
    url.JWT_LOGIN,
    {},
    {
      headers: {
        Authorization: `Basic ${btoa(
          unescape(
            encodeURIComponent(`${data.login.toLowerCase()}:${data.password}`)
          )
        )}`,
      },
      withCredentials: true,
    }
  )
}

const postLogout = data => {
  return get(url.JWT_LOGOUT)
}

const changePass = data => {
  const oldPassword = data.currentPassword
  const newPassword = data.password
  return post(url.CHANGE_PASS, {
    oldPassword,
    newPassword,
  })
}

const getRefreshToken = () => {
  return getPrivate(url.REFRESH_TOKEN)
}

const changePassViaEmail = email => {
  return postNoCookies(url.CHANGE_PASS_VIA_EMAIL, {
    email,
  })
}

const postVerify2MFA = ({ userId, token, temporaryToken }) => {
  return post(url.VERIFY_2_MFA, {
    userId,
    token,
    temporaryToken,
  })
}

export {
  postLogin,
  postLogout,
  changePass,
  getRefreshToken,
  changePassViaEmail,
  postVerify2MFA,
}
